import * as React from 'react';
import { useTheme } from '../../../../theme';
import cn from 'classnames';
import ButtonBase from '@material-ui/core/ButtonBase';
import { Add } from '../../../../Icons';
const Service = ({ children, selected, icon, onClick }) => {
    const theme = useTheme('FlightInfoCard').SegmentServices;
    return (React.createElement("div", { className: cn(theme.service, { [theme.service_selected]: selected }), onClick: onClick },
        React.createElement("div", { className: theme.service__icon }, icon),
        children,
        !selected && React.createElement(ButtonBase, { className: theme.service__add }, Add)));
};
export default Service;
